import {forwardRef, useImperativeHandle, useState} from "react";
import {t} from "i18next";
import {ipcSend} from "@/common/ipc";
import {postMessage} from "@/common/event";
import {
    DESKTOP_PRO_FROM_IMPORT_FILE,
    DESKTOP_PRO_FROM_UPGRADE,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    HOME_LEFT_MENU_WIDTH
} from "@/Const";
import {isZh} from "@/language";
import {getImagePath, getImagePathWithThemeSvg, isDarkMode} from "@/utils";

const DialogFreeUserUpgrade = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const [isShowDialog,setIsShowDialog] = useState(true);
    const onShowDialog = (szVersion:string)=>{
        setIsShowDialog(true);
    }
    return(
        <>
            {
                isShowDialog &&
                <div className={'div-dialog-free-user-upgdrade-container'} style={{
                    background: 'var(--dialog-free-user-upgrade-background)',
                    marginLeft:'3px',
                    marginBottom:'58px',
                    width: `${HOME_LEFT_MENU_WIDTH - 22}px`,
                    marginTop:'16px',
                    padding: '12px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    flexShrink:'0',
                }} onClick={()=>{
                    // if (isZh()) {
                    //     ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    // }else {
                    //     ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    // }
                }}>
                    <div className={'flex-row-vertical-center'}>
                        <img className={'img-20'} src={getImagePath('upgrade_to_pro.svg')}/>
                        <span className={'dialog-title font-family-semi-bold ml-10'}
                              style={{color: isDarkMode() ? '#FFFFFF' : '#000000'}}>{t("Upgrade To Pro")}</span>
                    </div>

                    <div className={'mt-10'}>
                        <span style={{color: isDarkMode() ? '#6D7986':'#333333'}}>{t("ElevateYourExperience")}</span>
                    </div>
                    {/*<div className={'flex-row-vertical-center mt-12'}>*/}
                        {/*<div className={'button-border-gray-style flex-center'} onClick={()=>{*/}
                        {/*    setIsShowDialog(false)*/}
                        {/*}}*/}
                        {/*     style={{width: '104px', height: '34px'}}>*/}
                        {/*    {t("Later")}*/}
                        {/*</div>*/}

                        <div className={'button-solid-style flex-center font-family-medium'} style={{width: '100%', height: '36px',marginTop:'10px',background:'#3C84F6',color:isDarkMode()?'black':'white',borderRadius:'12px'}} onClick={()=>{
                            if (isZh()) {
                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                            }else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                            }
                        }}>
                            {t("Upgrade now")}
                        </div>
                    {/*</div>*/}
                </div>
            }
        </>

    )
})

export default DialogFreeUserUpgrade;